import { useState } from 'react';
import AdminHeader from '../components/common/AdminHeader';
import RolePermissions from '../components/masters/RolePermissions';
import UserPermissions from '../components/masters/UserPermissions';
import { Shield, User } from 'lucide-react';

type PermTab = 'roles' | 'users';

export default function Permissions() {
  const [activeTab, setActiveTab] = useState<PermTab>('roles');

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-full mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <button
            onClick={() => setActiveTab('roles')}
            className={`flex flex-row items-center justify-center gap-4 px-6 py-4 rounded-lg font-semibold transition-all ${
              activeTab === 'roles'
                ? 'bg-brand-500 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
            }`}
          >
            <Shield className="w-5 h-5" />
            <span>Role Permissions</span>
          </button>
          <button
            onClick={() => setActiveTab('users')}
            className={`flex flex-row items-center justify-center gap-4 px-6 py-4 rounded-lg font-semibold transition-all ${
              activeTab === 'users'
                ? 'bg-brand-500 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
            }`}
          >
            <User className="w-5 h-5" />
            <span>User Permissions</span>
          </button>
        </div>

        {activeTab === 'roles' ? <RolePermissions /> : <UserPermissions />}
      </main>
    </div>
  );
}
